import { Swiper, Navigation, Autoplay, EffectFade, Lazy, Pagination, Scrollbar  } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Autoplay, EffectFade, Lazy, Navigation, Pagination, Scrollbar]);


document.addEventListener('DOMContentLoaded',function() {

    const about = document.getElementsByClassName('js-aboutSwiper')[0],
          //areas = document.getElementsByClassName('js-areasSwiper')[0],
          boxes = document.getElementsByClassName('js-boxesSwiper')[0],
          cards = document.querySelector('.js-cardsSwiper'),
          gallery = document.getElementsByClassName('js-gallerySwiper')[0],
          hubbenefits = document.querySelector('.js-hubbenefits'),
          newsfb = document.getElementsByClassName('js-newsFbSwiper')[0],
          promoted = document.querySelector('.js-promotedSwiper'),
          reviews = document.getElementsByClassName('js-reviewsSwiper')[0],
          standout = document.getElementsByClassName('js-standoutSwiper')[0],
          scrollbar = document.querySelectorAll('.js-scrollbarSwiper');

    const aboutCarousel = function() {
	    const swiper = new Swiper(about, {
            autoplay: {
                delay: 2000,
            },
            breakpoints: {
                768: {
                    paginatin: false
                }
            },
            effect: "fade",
            navigation: {
                nextEl: '.c-about .swiper-button-next',
                prevEl: '.c-about .swiper-button-prev',
            },
            pagination: {
                el: '.c-about .swiper-pagination',
                    clickable: true
            },
            speed: 800
            });
    };

    const boxesCarousel = function() {
	    let swiper, mobile;

        const carousels = {
            destroy: function() {
                if (swiper != undefined) {
                    swiper.destroy(true,true);
                }
            },
            start: function() {
                swiper = new Swiper(boxes, {
                    centeredSlides: true,
                    slidesPerView: 'auto',
            	    pagination: {
                        el: boxes.querySelector('.swiper-pagination'),
                        clickable: true
                    },
            	    spaceBetween: 16,
                    speed: 800
                });
            }
        }

        const init = function() {
            if (window.innerWidth > 1200) {
                if (mobile === true) {
                    carousels.destroy();
                    mobile = false;
                }

            } else {
                if (!mobile) {
                    carousels.start();
                    mobile = true;
                }
            }
        }

        init();
        window.addEventListener('resize', init);
    };

    const cardsCarousel = ()=> {
        let swiper;
        let mediaQuery = '(max-width: 1150px)',
            mediaQueryList = window.matchMedia(mediaQuery);

        const start = ()=> {
    	    swiper = new Swiper(cards, {
        	    modules: [Pagination],
                breakpoints: {
                    1151: {
                        pagination: 0
                    },
                },
                centeredSlides: true,
                pagination: {
                    el: '.swiper-pagination',
                        clickable: true
                },
               // slidesOffsetAfter: 17,
               // slidesOffsetBefore: 17,
                slidesPerView: 'auto',
                spaceBetween: 17,
                speed: 500
            });
        }

        mediaQueryList.addEventListener('change', event => {
            event.matches ? start() : swiper.destroy();
        })

        mediaQueryList.matches ? start() : false;
    };

    const galleryCarousel = function() {
        const swiper = new Swiper(gallery, {
            centeredSlides: true,
            lazy: {
                checkInView: true,
                loadPrevNext: true,
                loadPrevNextAmount: 3
            },
            navigation: {
                nextEl: gallery.parentNode.getElementsByClassName('swiper-button-next')[0],
                prevEl: gallery.parentNode.getElementsByClassName('swiper-button-prev')[0]
            },
            loop: true,
            preloadImages: false,
            slidesPerView: 'auto',
            speed: 500,
            spaceBetween:15,
            pagination: {
                el: '.c-gallery .swiper-pagination',
                clickable: true
            },
            slideToClickedSlide: true
        });
    };

    window.hubbenefits_carousel = () => {
        const hubbenefits = document.querySelector('.js-hubbenefits');
        if(!hubbenefits) return;

        let mediaQuery = '(max-width: 768px)',
            mediaQueryList = window.matchMedia(mediaQuery),
            swiper;

        const start = ()=> {
            swiper = new Swiper(hubbenefits, {
                centeredSlides: true,
                //centeredSlidesBounds: 1,
                slidesPerView: 'auto',
                //slidesPerGroup: 2,
                modules: [Navigation, Pagination],
                navigation: {
                    nextEl: hubbenefits.parentNode.querySelector('.swiper-button-next'),
                    prevEl: hubbenefits.parentNode.querySelector('.swiper-button-prev')
                },
                pagination: {
                    el: hubbenefits.querySelector('.swiper-pagination'),
                    clickable: true
                },
                touchMoveStopPropagation: false,
                //spaceBetween: 16,
                speed: 800
    	    });
        }

        mediaQueryList.addEventListener('change', event => {
            event.matches ? start() : swiper.destroy();
        })

        mediaQueryList.matches ? start() : false;
    }

    const newsfbCarousel = function() {
	    let swiper, mobile;

	    const el = document.getElementById('newsfb');
        const items = el.getElementsByClassName('is-hidden'),
              slidehidden = el.getElementsByClassName('is-slideout'),
              btn = el.getElementsByClassName('js-showmore')[0];

        const showMore = function(e) {
            e.currentTarget.style.display = 'none';
            while(items.length > 0){
                items[0].classList.remove('is-hidden');
            }

            setTimeout(function() {
                while(slidehidden.length > 0){
                    slidehidden[0].classList.remove('is-slideout');
                }

            }, 100);

            if (mobile === true) {
                carousels.destroy();
                carousels.start();
            }

            e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        };

        btn.addEventListener('click', showMore);

        const carousels = {
            destroy: function() {
                if (swiper != undefined) {
                    swiper.destroy(true,true);
                }
            },
            start: function() {
                swiper = new Swiper(newsfb, {
            	    breakpoints: {
                        // when window width is >= 320px
                        521: {
                            slidesPerView: 2,
                        },
                        821: {
                            slidesPerView: 3,
                        },

                    },
            	    pagination: {
                        el: '.c-newsfb .swiper-pagination',
                        clickable: true,
                        dynamicBullets: true
                    },
                    centeredSlides: true,
            	    watchSlidesProgress: true
                });
            }
        }

        const init = function() {
            if (window.innerWidth > 1024) {
                if (mobile === true) {
                    carousels.destroy();
                    mobile = false;
                }

            } else {
                if (!mobile) {
                    carousels.start();
                    mobile = true;
                }
            }
        }

        init();
        window.addEventListener('resize', init);
    };

    window.scrollbarCarousel = () => {
        let swiper = [];
        let scrollbar = document.querySelectorAll('.js-scrollbarSwiper')
        if(scrollbar.length === 0) return;

        for (let i = 0; i < scrollbar.length; i++) {
            swiper[i] = new Swiper(scrollbar[i], {
                centeredSlides: true,
                centeredSlidesBounds: 1,
                slidesPerView: 'auto',
        	    breakpoints: {
                    769: {
                        centeredSlides: false,
                        slidesOffsetAfter: 20,
                        spaceBetween: 40,
                    },
                },
                modules: [Navigation, Pagination, Scrollbar],
                navigation: {
                    nextEl: scrollbar[i].parentNode.querySelector('.swiper-button-next'),
                    prevEl: scrollbar[i].parentNode.querySelector('.swiper-button-prev')
                },
                pagination: {
                    el: scrollbar[i].querySelector('.swiper-pagination'),
                    clickable: true
                },
                touchMoveStopPropagation: false,
                scrollbar: {
                    el: scrollbar[i].parentNode.querySelector('.swiper-scrollbar'),
                    draggable: true,
                    dragSize: 50,
                    hide: false
                },
                spaceBetween: 16,
                speed: 800
            });
        }
    };

    window.promotedCarousel = function() {

        let swiper, mobile;

        const carousels = {
            destroy: function() {
                if (swiper != undefined) {
                    swiper.destroy(true,true);
                }
            },
            start: function() {
                swiper = new Swiper(promoted, {
            	    centeredSlides: true,
            	    slidesPerView: 1,
                    breakpoints: {
                        521: {
                    	    centeredSlides: false,
                            slidesPerView: 2,
                        },
                        1025: {
                            centeredSlides: false,
                            slidesPerView: 4,
                        }
                    },
                    pagination: {
                        el: document.querySelector('.js-promotedSwiper').querySelector('.swiper-pagination'),
                            clickable: true
                    },
                    spaceBetween: 16,
                    speed: 800
                });
            }
        }

        const init = function() {
            if (window.innerWidth > 1024) {
                if (mobile === true) {
                    carousels.destroy();
                    mobile = false;
                }

            } else {
                if (!mobile) {
                    carousels.start();
                    mobile = true;
                }
            }
        }

        init();
        window.addEventListener('resize', init);


       // carousels.start();


      /*
 const swiper = new Swiper(document.querySelector('.js-promotedSwiper'), {
    	    centeredSlides: true,
    	    slidesPerView: 1,
            breakpoints: {
                521: {
            	    centeredSlides: false,
                    slidesPerView: 2,
                },
                1025: {
                    centeredSlides: false,
                    slidesPerView: 4,
                }
            },
            pagination: {
                el: document.querySelector('.js-promotedSwiper').querySelector('.swiper-pagination'),
                    clickable: true
            },
            spaceBetween: 16,
            speed: 800
        });
*/
    };

    const reviewsCarousel = function() {
        const swiper = new Swiper(reviews, {
            centeredSlides: true,
            slidesPerView: 'auto',
    	    breakpoints: {
                769: {
                     centeredSlides: false,
                     spaceBetween: 20,
                },
            },
            navigation: {
                nextEl: reviews.parentNode.querySelector('.swiper-button-next.reviews'),
                prevEl: reviews.parentNode.querySelector('.swiper-button-prev.reviews')
            },
            pagination: {
                el: reviews.querySelector('.swiper-pagination'),
                clickable: true
            },
            touchMoveStopPropagation: false,
            scrollbar: {
                el: '.c-reviews .swiper-scrollbar',
                draggable: true,
                dragSize: 50,
                hide: false
            },
            slidesOffsetAfter: 20,
    	    spaceBetween: 16,
            speed: 800
        });
    };

    const standoutCarousel = function() {
	    let swiper, mobile;

        const carousels = {
            destroy: function() {
                if (swiper != undefined) {
                    swiper.destroy(true,true);
                }
            },
            start: function() {
                swiper = new Swiper(standout, {
            	    breakpoints: {
                        // when window width is >= 320px
                        521: {
                            slidesPerView: 2,
                        },
                    },
            	    pagination: {
                        el: '.c-standout .swiper-pagination',
                            clickable: true
                    },
                    centeredSlides: true,
            	    slidesPerView: 'auto',
                    speed: 800
                });
            }
        }

        const init = function() {
            if (window.innerWidth > 768) {
                if (mobile === true) {
                    carousels.destroy();
                    mobile = false;
                }

            } else {
                if (!mobile) {
                    carousels.start();
                    mobile = true;
                }
            }
        }

        init();
        window.addEventListener('resize', init);
    };

    window.carousels = function() {
        about ? aboutCarousel() : false;
        //areas ? areasCarousel() : false;
        boxes ? boxesCarousel() : false;
        cards ? cardsCarousel() : false;
        gallery ? galleryCarousel() : false;
        // hubbenefits ? hubbenefits_carousel() : false;
        newsfb ? newsfbCarousel() : false;
        promoted ? promotedCarousel() : false;
        reviews ? reviewsCarousel() : false;
        scrollbar.length > 0 ? scrollbarCarousel() : false;
        standout ? standoutCarousel() : false

    }

}, false)
